import React from 'react';
import { loaderCSS } from './Loader.css';

function Loader({ msg = '' }) {
    return (
        <div css={loaderCSS()} className='w-full h-full flex justify-center items-center flex-column'>
            <span className="loader-svg-wrap">
                <svg
                    className="loader-svg"
                    width="154"
                    height="92"
                    viewBox="0 0 154 92"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient id="loader-grad" x1="5" y1="47.3905" x2="149" y2="47.3905" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#00BA6E" />
                            <stop offset="1" stopColor="#32B8DF" />
                        </linearGradient>
                        <filter id="loader-glow">
                            <feGaussianBlur stdDeviation="3" result="blur" />
                            <feMerge>
                                <feMergeNode in="blur" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                    </defs>
                    <path
                        className="loader-path"
                        d="M83.4803 33.9912C78.2136 17.644 62.7721 5.86615 44.6194 6.12321C22.5937 6.43459 4.77768 24.7151 5.0021 46.7466C5.2229 68.7673 23.1367 86.5518 45.2058 86.5518C54.9753 86.5518 64.2453 83.4235 70.8983 77.2685C88.6817 60.8236 138.499 7.86111 138.499 7.86111C142.329 3.92911 149 6.64096 149 12.1334V88"
                        stroke="url(#loader-grad)"
                        strokeWidth="10"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        filter="url(#loader-glow)"
                    />
                </svg>
            </span>
            {msg && <p className='Center'>{msg}</p>}
        </div>
    );
}

export { Loader };
